import React from "react";
import { Crown } from "lucide-react";

// Original circular emblem built with CSS (not a copy of any real logo artwork).
const BrandBadge = ({ site }) => {
  const initials = site?.initials || "AK";
  const name = site?.name || "AKBook";
  const features = site?.features || [];
  const logo = site?.logo;
  const accent = site?.accentColor || "#f6c453";

  const ringStyle = {
    background: `conic-gradient(from 210deg, ${accent}, ${accent}55, ${accent}, ${accent}33, ${accent})`,
    boxShadow: `0 0 0 2px ${accent}59, 0 0 60px ${accent}40, 0 0 120px rgba(37, 211, 102, 0.18)`,
  };

  return (
    <div className="relative z-10 flex items-center justify-center">
      <div className="badge-ring rounded-full p-[3px] w-[260px] h-[260px] sm:w-[300px] sm:h-[300px]" style={ringStyle}>
        <div className="badge-inner rounded-full w-full h-full flex flex-col items-center justify-center overflow-hidden text-center">
          {logo ? (
            <img src={logo} alt={name} className="w-full h-full object-cover rounded-full" />
          ) : (
            <div className="flex flex-col items-center justify-center px-6">
              <Crown className="w-7 h-7 -mb-1" style={{ color: accent }} strokeWidth={2.2} />
              <div className="font-display font-extrabold text-4xl sm:text-5xl leading-none tracking-tight" style={{ color: accent }}>
                {initials}
              </div>
              <div className="font-display font-bold text-lg tracking-[0.2em] mt-1" style={{ color: accent }}>
                {name.toUpperCase()}
              </div>
              <div className="grid grid-cols-3 gap-1.5 mt-3 w-full max-w-[220px]">
                {features.slice(0, 3).map((f, i) => (
                  <span key={`${f}-${i}`} className="text-[8px] sm:text-[9px] leading-tight font-medium uppercase" style={{ color: `${accent}cc` }}>
                    {f}
                  </span>
                ))}
              </div>
              <div className="mt-3 bg-[#25D366] text-white text-[10px] sm:text-xs font-bold px-3 py-1 rounded-full shadow-lg">
                Click here for Active WhatsApp
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BrandBadge;
